module.exports = __webpack_public_path__ + "media/images/home/fv_present-efe1072ae9d608532078ca6e8af652d4.png";